export const meta = Object.freeze({
	popupOptions: {
		id: 'booking-cycle-popup',
		width: 540,
		height: 500,
		padding: 20,
		overlay: true,
		cacheable: false,
		autoHide: true,
		closeByEsc: true,
		animation: 'fading',
		closeIcon: {
			top: '14px',
			right: '14px',
		},
	},
});
